import ajax from '../utils/axios'

// 下家问题件列表
export const GetNextFamilyList = (params) => ajax.get(`/index/carrier/index?limit=${params.limit}&page=${params.page}&carrier_id=${params.carrier_id}&order_number=${params.order_number}&status=${params.status}&problem_id=${params.problem_id}&start_cost_time=${params.start_cost_time}&end_cost_time=${params.end_cost_time}&start_create_time=${params.start_create_time}&end_create_time=${params.end_create_time}&create_uid=${params.create_uid}`)

// 修改下家问题件
export const PostNextFailyEdit = (params) => ajax.post('/index/carrier/edit', params)

// 获取当前公司下用户列表
export const GetSellerUserList = (params) => ajax.get('/index/user/get_firm_user_list', params)

// 获取可以发送的组织列表
export const GetNextFailyFirmList = (params) => ajax.get('/index/order/firm_list', params)

// 获取问题列表
export const GetNextFailyProblemList = (params) => ajax.get('/index/order/problem_list', params)

// 解除结单
export const PostNextFailyReverseStatus = (params) => ajax.post('/index/carrier/reverse_status', params)

// 批量结单
export const CarrierBatchCheck = (params) => ajax.post('/index/carrier/batch_check', params)

// 导出数据
export const PostNextFailyExport = (params) => ajax.downloadFile('/index/carrier/export', params)

// 获取筛选列表的下家列表
export const GetNextFailyGetCarrier = () => ajax.get('/index/carrier/get_carrier')

// 获取问题件详情
export const PostNextFailyOrderDetail = (params) => ajax.post('/index/carrier/order_detail', params)

// 结单
export const PostNextFailyFinishOrder = (params) => ajax.post('/index/carrier/finish_order', params)

// 修改附加费用
export const PostNextFailyEditCost = (params) => ajax.post('/index/carrier/edit_cost', params)

// 添加留言
export const PostNextFailySendMessage = (params) => ajax.post('/index/carrier/send_message', params)

// 新增下家问题件
// export const PostNextFailyAdd = (params) => ajax.post('/order/add', params)
